import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, ThemeProvider, createTheme } from '@mui/material';
import GettingStarted from './GettingStarted';
import UserGuide from './UserGuide';
import ApiDocumentation from './ApiDocumentation';

const primaryColor = '#4c43a3';

const theme = createTheme({
    palette: {
        primary: {
            main: primaryColor,
        },
        background: {
            default: '#ffffff',
            paper: '#ffffff',
        },
        text: {
            primary: '#000',
            secondary: '#666666',
        },
    },
    typography: {
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        h3: {
            fontWeight: 700,
        },
        h4: {
            fontWeight: 700,
        },
        h5: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 600,
        },
    },
    components: {
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '1rem',
                    minWidth: 120,
                    '&.Mui-selected': {
                        fontWeight: 600,
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    height: 3,
                    borderRadius: '3px 3px 0 0',
                },
            },
        },
    },
});

const TabPanel = ({ children, value, index }) => {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`resources-tabpanel-${index}`}
            aria-labelledby={`resources-tab-${index}`}
            sx={{ py: 4 }}
        >
            {value === index && children}
        </Box>
    );
};

const a11yProps = (index) => {
    return {
        id: `resources-tab-${index}`,
        'aria-controls': `resources-tabpanel-${index}`,
    };
};

const SupportDocs = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (_event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    bgcolor: '#ffffff',
                    fontFamily: 'Inter, sans-serif',
                    borderRadius: 2,
                }}
            >
                <Box sx={{ px: { xs: 2, sm: 3, md: 3 }, py: 3 }}>
                    {/* Header */}
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            color: '#1a1a2e',
                            mb: 2,
                        }}
                    >
                        Support Docs
                    </Typography>

                    {/* Tabs */}
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            aria-label="Resources tabs"
                            sx={{
                                '& .MuiTab-root': {
                                    color: '#666',
                                    '&:hover': {
                                        color: primaryColor,
                                    },
                                },
                                '& .Mui-selected': {
                                    color: `${primaryColor} !important`,
                                },
                            }}
                        >
                            <Tab label="Getting Started" {...a11yProps(0)} />
                            <Tab label="User Guide" {...a11yProps(1)} />
                            <Tab label="API Documentation" {...a11yProps(2)} />
                        </Tabs>
                    </Box>

                    {/* Tab Panels */}
                    <TabPanel value={tabValue} index={0}>
                        <GettingStarted />
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        <UserGuide />
                    </TabPanel>
                    <TabPanel value={tabValue} index={2}>
                        <ApiDocumentation />
                    </TabPanel>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default SupportDocs;
